import React from 'react';
import CircularProgress, {CircularProgressProps} from '@material-ui/core/CircularProgress';
import {createReactMapboxControl} from '../../../utils/mapbox/Mapbox';

export interface LoadingControlProps extends CircularProgressProps {
    isLoading: boolean;
}

function LoadingControl({isLoading, ...props}: LoadingControlProps) {
    if (!isLoading) return null;

    return (<CircularProgress
        thickness={7}
        className='mapboxgl-ctrl'
        disableShrink
        {...props}
    />);
}

export default createReactMapboxControl(LoadingControl);
